export const findMax = (field, data) =>
  data.reduce((maxArea, item) => (maxArea < item[field] ? item[field] : maxArea), data[0][field]);

const ZERO_VALUE_MESSAGE = 'Укажите этаж больше или меньше 0';
const EMPTY_FLOOR_VALUE_MESSAGE = 'Укажите этаж';
const EMPTY_FLOORS_VALUE_MESSAGE = 'Укажите этажи';
const FLOOR_MAX_EXCEEDED_MESSAGE = 'Этаж слота не может быть больше общего количества этажей';
const FLOORS_MAX_EXCEEDED_MESSAGE = 'Этажи слота не могут быть больше общего количества этажей';

export const getValidationMessage = (field, value, state, areaPart) => {
  const isValidatingValueZero = value === 0;
  const isValidatingValueNull = value === null;

  switch (field) {
    case 'area': {
      if (!value) {
        return 'Укажите площадь в м²';
      }

      return null;
    }

    case 'price': {
      if (!value) {
        return 'Укажите стоимость';
      }

      return null;
    }

    case 'floorFrom': {
      const { floorsCount } = state.building;
      const { floorTo } = areaPart;
      const isFloorToBiggerThanMax = floorsCount && floorTo > floorsCount;
      const isValueBiggerThanMax = value && floorsCount && value > floorsCount;
      const isFloorToZero = floorTo === 0;
      const isFloorToNull = floorTo === null;

      if (isValidatingValueNull) {
        // [null, null]
        // Валидация обрабатывается в case 'floorTo'
        if (isFloorToNull) {
          return '';
        }

        // [null, Y !== 0]
        return EMPTY_FLOOR_VALUE_MESSAGE;
      }

      if (isValidatingValueZero) {
        // [0, 0]
        // Валидация обрабатывается в case 'floorTo'
        if (isFloorToZero) {
          return '';
        }

        // [0, Y !== 0]
        return ZERO_VALUE_MESSAGE;
      }

      if (isValueBiggerThanMax) {
        // [X > max, Y > max]
        // Валидация обрабатывается в case 'floorTo'
        if (isFloorToBiggerThanMax) {
          return '';
        }

        // [X > max, 0 | null | undefined]
        if (!floorTo) {
          return FLOOR_MAX_EXCEEDED_MESSAGE;
        }
      }

      return null;
    }

    // Для этого кейса на форме всегда есть поле "от" и поле "до"
    case 'floorTo': {
      const { floorsCount } = state.building;
      const { floorFrom } = areaPart;
      const isFloorFromBiggerThanMax = floorsCount && floorFrom > floorsCount;
      const isValueBiggerThanMax = value && floorsCount && value > floorsCount;
      const isFloorFromZero = floorFrom === 0;
      const isFloorFromNull = floorFrom === null;

      // [0 | null, X]
      // Валидация обрабатывается в case 'floorFrom'
      if (value && !floorFrom) {
        return '';
      }

      if (isValidatingValueZero) {
        // [0, 0]
        if (isFloorFromZero) {
          return ZERO_VALUE_MESSAGE;
        }

        // [null, 0] или [X > max, 0]
        // Валидация обрабатывается в case 'floorFrom'
        if (isFloorFromNull || isFloorFromBiggerThanMax) {
          return '';
        }

        // [X <= max, 0]
        return ZERO_VALUE_MESSAGE;
      }

      if (isValidatingValueNull) {
        // [null, null]
        if (isFloorFromNull) {
          return EMPTY_FLOORS_VALUE_MESSAGE;
        }

        // [0, null] или [X > max, null]
        // Валидация обрабатывается в case 'floorFrom'
        if (isFloorFromZero || isFloorFromBiggerThanMax) {
          return '';
        }

        // [X <= max, null]
        return EMPTY_FLOOR_VALUE_MESSAGE;
      }

      if (isValueBiggerThanMax && isFloorFromBiggerThanMax) {
        return FLOORS_MAX_EXCEEDED_MESSAGE;
      }

      if (isValueBiggerThanMax) {
        return FLOOR_MAX_EXCEEDED_MESSAGE;
      }

      return null;
    }

    default:
      return null;
  }
};
